import React from "react";
import classes from "./FormItems.module.css";

const FormErrors = ({ error }) => {
  if (!error) return null;
  return <p className={classes.error_message}>{error}</p>;
};

export default FormErrors;
